// extracted by mini-css-extract-plugin
module.exports = {"emptyProductWrapper":"empty-product_emptyProductWrapper__p3cEp"};